module.exports = __webpack_public_path__ + "img/23.59706705.png";